import * as apiSW from 'api/ingredient/GetIngredientStartingWithV1';
import Ingredient from 'classes/_general/Search/Ingredient/Ingredient';
import { IExclusionLogicSelectItem } from 'interfaces/IExclusionLogicSelectItem';

export default class IngredientList {
	public all: Ingredient[] = [];
	public filtered: IExclusionLogicSelectItem[] = [];

	public async initialize(): Promise<void> {
		const response = await apiSW.callApi('', false);
		response.hasValue() && this.mapFromApi(response.get());
	}

	public async search(searchTerm: string): Promise<void> {
		const filtered: Ingredient[] = this.all.filter((e: Ingredient) =>
			e.name.toLowerCase().startsWith(searchTerm.toLowerCase())
		);
		this.filtered = this.mapToSelectItems(filtered);
	}

	public getById(id: string): Ingredient | undefined {
		const index = this.all.findIndex((x) => x.id == id);
		return this.all[index];
	}

	private mapToSelectItems(input: Ingredient[]): IExclusionLogicSelectItem[] {
		return input.map((e: Ingredient) => {
			return e.mapToSelectItem();
		});
	}

	private mapFromApi(input: apiSW.ResponseIngredient[]): void {
		this.all = [];
		for (const i of input) {
			const ingredient: Ingredient = new Ingredient(i);
			this.all.push(ingredient);
		}
	}
}
